"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileUpload = exports.ImageUpload = void 0;
var ImageUpload_1 = require("./ImageUpload");
Object.defineProperty(exports, "ImageUpload", { enumerable: true, get: function () { return ImageUpload_1.ImageUpload; } });
var FileUpload_1 = require("./FileUpload");
Object.defineProperty(exports, "FileUpload", { enumerable: true, get: function () { return FileUpload_1.FileUpload; } });
